import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import ShareYourBuildContent from './ShareYourBuildModalContent';
import { PaymentFrequency, selectPrimaryCalculatorPaymentOptions } from '../../core/reducers/financialCalculators';
import { useAppSelector } from '../../core/utils';
const ShareYourBuild = ({ bigExteriorImage, nameBadge, vehicle, paymentData, modelImage, gtmFields, }) => {
    var _a, _b;
    const { t } = useTranslation();
    const modelName = vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelName;
    const modelYear = vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelYear;
    const trimName = vehicle === null || vehicle === void 0 ? void 0 : vehicle.trimName;
    const transmissionName = (_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.transmission) === null || _a === void 0 ? void 0 : _a.transmissionName;
    const modelTitle = `${vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelYear} ${vehicle === null || vehicle === void 0 ? void 0 : vehicle.trimName} ${(_b = vehicle === null || vehicle === void 0 ? void 0 : vehicle.transmission) === null || _b === void 0 ? void 0 : _b.transmissionName}`;
    const { paymentMethod, paymentFrequency } = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    const priceLabel = t(`Pages.Bap.estimated${capitalize(paymentMethod)}Label`);
    const paymentFrequencyLabelKey = paymentFrequency === PaymentFrequency.biweekly ? 'biWeekly' : paymentFrequency;
    const paymentFrequencyLabel = t(`Shared.Common.PaymentFrequency.${paymentFrequencyLabelKey}`);
    return (_jsx(ShareYourBuildContent, { vehicleImage: modelImage, bigExteriorImage: bigExteriorImage, modelTitle: modelTitle, modelBadgeImage: nameBadge, paymentData: paymentData, priceLabel: priceLabel, paymentFrequencyLabel: paymentFrequencyLabel, ctaText: t('Pages.Bap.downloadPdfButton'), copyButtonText: t('Pages.Bap.copyButton'), modelYear, transmissionName, trimName, description: t('Pages.Bap.shareYourBuildModalText', {
            modelName,
            modelYear,
            trimName,
            transmissionName,
        }), gtmFields: gtmFields }));
};
export default ShareYourBuild;
